import { Svg } from './svg'

export const LockIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 9C6.89543 9 6 9.89543 6 11C6 12.1046 6.89543 13 8 13C9.10457 13 10 12.1046 10 11C10
    9.89543 9.10457 9 8 9Z"
      fill="#313131"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4V6H1C0.447715 6 0 6.44772 0 7V15C0 15.5523 0.447715 16 1 16H15C15.5523 16 16 15.5523
      16 15V7C16 6.44772 15.5523 6 15 6H12V4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4ZM8 2C6.89543 2 6 2.89543 6 4V6H10V4C10 2.89543
      9.10457 2 8 2ZM2 8V14H14V8H2Z"
      fill="#313131"
    />
  </Svg>
)
